import { GrabHandle } from 'blaze-ui/icons'
import Styles from './SectionsSelection.module.scss'
import { useUnsplashImages } from 'components/Wizards/SelectImages/ImagesProvider'
import { Text } from 'blaze-ui/Text/Text'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'
import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'
import cx from 'classnames'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'

export const LoadingSections = ({ initialPosition = 0 }: { initialPosition?: number }) => {
  const { maxPhotos } = useUnsplashImages()

  return (
    <>
      {Array.from({ length: maxPhotos }).map((_, index) => (
        <div key={`loading-section-${index}`} className={Styles.section}>
          <ResponsiveDesign.Desktop>
            <div className={Styles.dragHandle}>
              <IconButton icon={GrabHandle} variant="editor" />
            </div>
          </ResponsiveDesign.Desktop>
          <div className={Styles.content}>
            <div className={Styles.data}>
              <div className={Styles.header}>
                <div className={Styles.top}>
                  <Text variant="secondary" color="var(--dark-40)">
                    Section Title #{index + initialPosition + 1}
                  </Text>
                </div>

                <div className={Styles.loadingTitle}>
                  <TextFieldLoadingState />
                </div>
              </div>
              <div className={Styles.imageContainer}>
                <LoadingShimmerer>
                  <div className={cx(Styles.imageEmptyState, Styles.isLoading)} />
                </LoadingShimmerer>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  )
}
